module.exports = __webpack_public_path__ + "img/女2.c7e509d8.png";